var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-detail"},[_c('div',{staticClass:"new-detail__container"},[_c('Breadcrumbs'),_c('div',{staticClass:"general-info__column"},[_c('AppSectionNewsDetails',{attrs:{"news_item":_vm.itemNews}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }